import { useState } from 'react';

type responseFunction = {
  offIsLoading: (value: boolean) => void;
  onIsLoading: (value: boolean) => void;
  isLoading: boolean;
};

function useIsLoading(initialValue: boolean): responseFunction {
  const [isLoading, setIsLoading] = useState(initialValue);

  function onIsLoading(value: boolean): void {
    setIsLoading(value);
  }

  function offIsLoading(value: boolean): void {
    setIsLoading(value);
  }

  return { offIsLoading, isLoading, onIsLoading };
}
export { useIsLoading };
